import { allowed } from './appointmentVariation';
import FeatureFlags from '../FeatureFlags';
import * as storage from '../KeyValueStorage';
import Analytics from '../analytics';
import { LinkTo } from '../../hooks/useLinkTo';

/* Plan Selection Functionality */
export const PRO_PLAN_SELECTION_EV3189 = 'pro_plan_selection_ev3189_20210125';

export const planSelectionEnabled = async (): Promise<boolean> => Promise.all([
  allowed({ checkFlagOnly: true }),
  FeatureFlags.isEnabled(PRO_PLAN_SELECTION_EV3189),
])
  .then(([
    inAppointmentVariationTest,
    ev3189Enabled,
  ]) => inAppointmentVariationTest && ev3189Enabled);

/* Plan Selection Redirect */
export const PRO_PAYMENT_SETUP_ABORT_REDIRECT_EV3188 = 'pro_payment_setup_abort_redirect_ev3188_20210201';

export const paymentSetupAbortRedirectEnabled = async (): Promise<boolean> => Promise.all([
  allowed({ checkFlagOnly: true }),
  FeatureFlags.areEnabled([
    PRO_PLAN_SELECTION_EV3189,
    PRO_PAYMENT_SETUP_ABORT_REDIRECT_EV3188,
  ]),
])
  .then(([
    inAppointmentVariationTest,
    flags,
  ]) => inAppointmentVariationTest
    && flags[PRO_PLAN_SELECTION_EV3189]
    && flags[PRO_PAYMENT_SETUP_ABORT_REDIRECT_EV3188]);

interface IHandlePaymentSetupFlowCancellationArgs {
  /** Source for tracking events */
  source: string,
  /** Callback Function for when the redirect to Plan Selection did not happen */
  callback: () => void,
  /** Provider ID */
  providerId: number,
  /** Function to use for state transitions */
  linkTo: LinkTo,
}

export const handlePaymentSignupFlowCancellation = async ({
  source,
  callback,
  providerId,
  linkTo,
}: IHandlePaymentSetupFlowCancellationArgs): Promise<void> => Promise
  .all([
    paymentSetupAbortRedirectEnabled(),
    storage.getItem('paymentSetupAbortRedirected'),
  ])
  .then(([enabled, redirected]) => {
    if (!enabled || redirected) {
      if (redirected) {
        Analytics.track('payment_signup_flow_cancelled_no_redirect', { source });
      }
      callback();
      return;
    }

    storage.setItem('paymentSetupAbortRedirected', true);

    Analytics.track('payment_signup_flow_cancelled_with_redirect', { source });

    linkTo(
      'provider.settings_menu.plan_selection',
      {
        source,
        providerId,
        initiatedFrom: source,
      },
    );
  });

/* Self-Service Plan Selection */
export const PRO_SELF_SERVICE_PLAN_CHANGE_EV3194 = 'pro_self_service_plan_change_ev3194_20210204';

export const selfServicePlanChangeEnabled = async (): Promise<boolean> => Promise.all([
  allowed({ checkFlagOnly: true }),
  FeatureFlags.areEnabled([
    PRO_PLAN_SELECTION_EV3189,
    PRO_SELF_SERVICE_PLAN_CHANGE_EV3194,
  ]),
])
  .then(([
    inAppointmentVariationTest,
    flags,
  ]) => inAppointmentVariationTest
    && flags[PRO_PLAN_SELECTION_EV3189]
    && flags[PRO_SELF_SERVICE_PLAN_CHANGE_EV3194]);
